import * as _ from "lodash";
import * as log from "loglevel";
import * as React from "react";

import { observable } from "mobx";
import { inject, observer, Provider } from "mobx-react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";


import { config } from "../config";
import { Dropdown, Icon, Image, Menu, Modal, Transition } from "semantic-ui-react";
import { AuthStore } from "../stores/auth-store";
import { ReleaseNoteStore } from "../stores/releasenote-store";
import { SystemMessageStore } from "../stores/system-message-store";
import { StartMenuState, UIStore } from "../stores/ui-store";
import { EditorPane } from "./common/editor-pane";
import { SystemMessage } from "./common/system-message";
import { ReleaseNoteModal } from "./release-note-modal";

interface INavBarProps {
	uiStore?: UIStore;
	authStore?: AuthStore;
	releaseNoteStore?: ReleaseNoteStore;
	systemMessageStore? : SystemMessageStore;
}

interface INavBarState {
	showProfileEditor: boolean;
	saving: boolean;
	showReleaseNotes: boolean;
}


@inject("uiStore", "authStore", "releaseNoteStore", "systemMessageStore") @observer
export class NavBar extends React.Component<INavBarProps, INavBarState>{
	constructor(props, state) {
		super(props, state);

		this.state = { "showProfileEditor": false, "saving": false, "showReleaseNotes": false };
		this.handleSignOut = this.handleSignOut.bind(this);
		this.handleShowProfileEditor = this.handleShowProfileEditor.bind(this);
		this.handleCloseProfileEditor = this.handleCloseProfileEditor.bind(this);
		this.showHelp = this.showHelp.bind(this);
		this.showReleaseNotes = this.showReleaseNotes.bind(this);
		this.closeReleaseNoteModal = this.closeReleaseNoteModal.bind(this);
	}


	async componentWillMount() {
		this.props.releaseNoteStore.loadNotes();
		this.props.systemMessageStore.loadSystemMessage();
	}

	handleSignOut() {
		this.props.authStore.logout();
	}

	handleShowProfileEditor() {
		this.setState({ "showProfileEditor": true });
	}

	handleCloseProfileEditor() {
		this.setState({ "showProfileEditor": false });
	}

	showHelp() {
		this.props.uiStore.setOptionData({ "introModal": true });
	}

	showReleaseNotes() {
		this.setState({ "showReleaseNotes": true });
		if (!_.isNil(this.props.uiStore.releaseVersionViewed) && !_.isNil(this.props.releaseNoteStore.notes)) {
			this.props.uiStore.setOptionData({ "releaseVersionViewed": this.props.releaseNoteStore.notes[0].id });
		}
	}

	closeReleaseNoteModal() {
		this.setState({ "showReleaseNotes": false });
	}


	render() {
		if (_.isNil(this.props.authStore.user)) {
			return (
				<div>

				</div>
			);
		}
		let showEditor = this.state.showProfileEditor;

		let avatar = this.props.authStore.user.avatarLink;
		avatar = _.isEmpty(avatar) ? "//cdn.jibunu.com/images/jibunu7.png" : avatar;

		let releaseNoteIcon = "sticky note outline";
		if (!_.isNil(this.props.uiStore.releaseVersionViewed) && !_.isNil(this.props.releaseNoteStore.notes)) {
			if (this.props.releaseNoteStore.notes.length > 0 && this.props.uiStore.releaseVersionViewed < this.props.releaseNoteStore.notes[0].id) {
				releaseNoteIcon = "sticky note jibunu-orange";
			}
		}

		return (
			<Menu attached="top" fluid borderless style={{"background": config.topBarBackgroundColor}}>
				{this.state.showReleaseNotes &&
					<ReleaseNoteModal close={this.closeReleaseNoteModal} />
				}
				<SystemMessage />
				<Link className="item" title="Home Page" to="/">
					<img src={`//cdn.jibunu.com/images/jibunu_2024_300_86.png`} style={{"width": "175px", "height": "50px"}}/>
				</Link>
				<Menu.Menu position="right" >
					<Dropdown icon={<Icon className={releaseNoteIcon} size="big" />} item onClick={this.showReleaseNotes} />
					<Dropdown icon={<Icon name="help" size="big" />} item onClick={this.showHelp} />
					{this.props.authStore.user.accountType == 0 && <Dropdown icon={<Icon name="settings" size="big" />} item>
						<Dropdown.Menu>
							{
								this.props.authStore.user.hasAdminAccess() &&
								<Link className="item" to="/apps">
									Applications
								</Link>
							}
							<Link className="item" to="/users">
								Users
							</Link>
							<Link className="item" to="/history">
								History
							</Link>
							<Link className="item" to="/admin">
								Admin
							</Link>
						</Dropdown.Menu>
					</Dropdown>}
					<Dropdown item icon={<div><img className="ui avatar image" src={avatar} /><span>{this.props.authStore.user.username}</span></div>}>
						<Dropdown.Menu>
							<Link className="item" to="/profile">
								<Icon name="user"></Icon>Profile
							</Link>
							<Dropdown.Item icon="sign out" text="Sign Out" onClick={this.handleSignOut}>
							</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				</Menu.Menu>
			</Menu>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/nav-bar.tsx